/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ResumeTileRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'
import {ResumeTileResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'


export const resumeTile = (request: ResumeTileRequest, options?: CashRequestOptions) => post<ResumeTileRequest, ResumeTileResponse>("/2.0/cash/resume-tile", request, {...options, rejectOnError: true })